import { Item } from "@/services/backend/htz/position-catalog/types/position-catalog";

export interface Position {
  id: string;
  number: string;
  airHandlingUnits: string[] | null;
  title: string;
  description: string;
  unitCount: number;
  unitPrice: number;
  totalPrice: number;
  unitHours: number;
  totalHours: number;
  optional: boolean;
}

/**
 * PositionPatch holds the fields of a position of an offer, order or
 * confirmation that may be patched. An omitted key leaves the field
 * unchanged. The totals are derived by the backend.
 */
export interface PositionPatch {
  title?: string;
  description?: string;
  airHandlingUnits?: string[];
  unitCount?: number;
  unitPrice?: number;
  unitHours?: number;
  optional?: boolean;
}

/**
 * positionPatchFromCatalog returns the fields a position created from the
 * catalog item is prefilled with.
 */
export function positionPatchFromCatalog(item: Item): PositionPatch {
  return {
    title: item.copyTitle ? item.title : "",
    description: item.copyDescription ? item.description : "",
    unitPrice: item.copyUnitPrice ? item.unitPrice : 0,
    unitHours: item.copyUnitHours ? item.unitHours : 0,
  };
}

/**
 * patchPosition returns the positions with the patch applied to the
 * position, the totals derived. It is the optimistic value of a patch, the
 * backend validates.
 */
export function patchPosition(
  positions: Position[],
  positionId: string,
  patch: PositionPatch,
): Position[] {
  return positions.map((p) => {
    if (p.id !== positionId) {
      return p;
    }
    const next = { ...p, ...patch };
    return {
      ...next,
      totalPrice: next.unitCount * next.unitPrice,
      totalHours: next.unitCount * next.unitHours,
    };
  });
}

export function positionErrorKey(position: Position, field: string): string {
  return `positions.${position.id}.${field}`;
}
